import ServiceBase from '@/services/ServiceBase';

const resource = 'api/v1/backoffice/invitation';

class InvitationService extends ServiceBase {
  constructor() {
    super({ resource });
  }

  getListReport = (params) => {
    const resourceReport = 'invitation-report/';
    const response = this.http.get(resourceReport, params);
    return response;
  }

  checkin = (invitationId, checkinForm) => {
    const action = 'check-in';
    const url = `${this.getUrl(invitationId)}${action}/`;
    const response = this.http.post(url, checkinForm);
    return response;
  }

  checkout = (invitationId, checkinForm) => {
    const action = 'check-out';
    const url = `${this.getUrl(invitationId)}${action}/`;
    const response = this.http.post(url, checkinForm);
    return response;
  }

  getCheckout = (invitationId) => {
    const action = 'check-out';
    const url = `${this.getUrl(invitationId)}${action}/`;
    const response = this.http.get(url);
    return response;
  }

  getCheckin = (invitationId) => {
    const action = 'check-in';
    const url = `${this.getUrl(invitationId)}${action}/`;
    const response = this.http.get(url);
    return response;
  }
}

export default InvitationService;



// WEBPACK FOOTER //
// ./src/services/InvitationService.js